function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 43.3492 43.3492",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_235822280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_235823816",
    d: "m25.1913 19.4288c-.2613 0-.4734-.212-.4734-.4732v-2.1443c0-1.12-.9109-2.0299-2.0309-2.0299h-2.0249c-1.12 0-2.031.9099-2.031 2.0299l.0002 2.1442c0 .2613-.2112.4733-.4734.4733-.2613 0-.4733-.212-.4733-.4732l.0002-2.1443c0-1.6415 1.3357-2.9764 2.9772-2.9764h2.0251c1.6415 0 2.9772 1.3349 2.9772 2.9764l.0001 2.1442c0 .2613-.212.4733-.4731.4733z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235824104",
    d: "m21.6747 10.4336c-.9376 0-1.7008.7631-1.7008 1.7007.0001.9375.763 1.7006 1.7006 1.7006s1.7007-.763 1.7007-1.7006-.7631-1.7007-1.7005-1.7007zm0 4.3478c-1.4603 0-2.6473-1.188-2.6473-2.6471.0001-1.4602 1.187-2.6471 2.6471-2.6471 1.4591-.0001 2.6471 1.187 2.6471 2.6471.0001 1.459-1.188 2.6471-2.6469 2.6471z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235824296",
    d: "m21.6747 8.2794c-1.4483 0-2.8977.5522-3.9999 1.6544-2.2054 2.2054-2.2054 5.794 0 7.9994 2.2056 2.2054 5.794 2.2054 7.9994 0 2.2056-2.2054 2.2054-5.794 0-7.9994-1.102-1.1023-2.5514-1.6543-3.9995-1.6544zm0 12.2545c-1.691 0-3.3818-.6437-4.6693-1.9312-2.5741-2.5742-2.5742-6.7632 0-9.3383 2.5751-2.5742 6.7631-2.5741 9.3382 0 2.5743 2.5751 2.5742 6.7641 0 9.3383-1.2874 1.2875-2.9783 1.9313-4.6689 1.9312z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235824272",
    d: "m36.8838 34.2228c-.2613 0-.4734-.2118-.4734-.4731l.0002-4.6839h-29.472v4.6839c0 .2612-.212.4732-.4733.4732-.2612-.0001-.4732-.2119-.4732-.4732l.0002-5.1572c0-.2613.2118-.4731.473-.4731l30.4185-.0001c.2613 0 .4731.212.4731.4733v5.1571c0 .2612-.2119.4732-.4731.4731z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235823960",
    d: "m21.6747 34.2228c-.2613 0-.4735-.2118-.4735-.4731l.0001-7.887c0-.2613.2119-.4732.4732-.4732.2613-.0001.4732.2119.4732.4732l.0002 7.887c0 .2612-.2121.4732-.4732.4731z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235824080",
    d: "m1.8721 34.2228c-.5106 0-.9257.4152-.9257.9269v4.7893c0 .5108.415.9258.9257.9258h9.1855c.5106 0 .9267-.415.9267-.9257l.0001-4.7895c0-.5116-.4162-.9267-.9268-.9267zm9.1855 7.5884h-9.1855c-1.0321 0-1.8722-.8399-1.8722-1.8721v-4.7895c0-1.0332.84-1.8731 1.8722-1.8731l9.1855-.0001c1.0332 0 1.8732.8401 1.8732 1.8733l.0001 4.7893c0 1.0323-.8401 1.8723-1.8733 1.8722z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235824152",
    d: "m17.0814 34.2228c-.5106 0-.9258.4152-.9258.9269l.0002 4.7893c0 .5108.4148.9258.9255.9258h9.1856c.5115 0 .9266-.415.9266-.9257l.0002-4.7895c0-.5116-.4153-.9267-.927-.9267zm9.1855 7.5884h-9.1855c-1.0321 0-1.8723-.8399-1.8723-1.8721l.0001-4.7895c0-1.0332.8399-1.8731 1.8721-1.8731l9.1856-.0001c1.0332 0 1.873.8401 1.873 1.8733l.0001 4.7893c0 1.0323-.8401 1.8723-1.8731 1.8722z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235823864",
    d: "m32.2905 34.2228c-.5106 0-.9257.4152-.9257.9269v4.7893c0 .5108.415.9258.9256.9258h9.1867c.5106 0 .9256-.415.9256-.9257l.0001-4.7895c0-.5116-.4152-.9267-.9259-.9267zm9.1866 7.5884h-9.1866c-1.0321 0-1.8722-.8399-1.8722-1.8721v-4.7895c0-1.0332.84-1.8731 1.8721-1.8731l9.1867-.0001c1.0321 0 1.872.8401 1.872 1.8733l.0002 4.7893c0 1.0323-.8402 1.8723-1.8722 1.8722z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235824248",
    d: "m9.7012 39.9824h-6.4715c-.2611 0-.4733-.2119-.4733-.4732l.0001-3.9307c0-.2613.2119-.4732.4732-.4732s.4732.212.4732.4732l.0002 3.4575h5.9981c.261 0 .473.212.473.4732.0001.2612-.212.4733-.473.4732z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235823120",
    d: "m5.1019 39.9824c-.2622 0-.4733-.2119-.4733-.4732l.0001-3.217c0-.2611.2109-.4731.4732-.4731.2613 0 .4732.212.4732.4732l.0001 3.2169c0 .2612-.2121.4733-.4733.4732z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235823408",
    d: "m6.9179 39.9824c-.2613 0-.4733-.2119-.4733-.4732l.0002-2.2696c0-.2611.2118-.4731.4731-.4731s.4731.212.4731.4732l.0001 2.2695c0 .2612-.212.4733-.4732.4732z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235823048",
    d: "m8.734 39.9824c-.2613 0-.4734-.2119-.4734-.4732v-1.6011c0-.2613.212-.4731.4732-.4731.2613-.0002.4733.2119.4733.4732l.0001 1.601c0 .2612-.2121.4733-.4732.4732z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235823384",
    d: "m21.0307 35.9708c-.5126 0-.9296.4172-.9296.9298s.417.9287.9296.9287c.5127 0 .9297-.416.9297-.9287 0-.5128-.417-.9297-.9297-.9298zm0 2.8049c-1.0341 0-1.8761-.8409-1.8761-1.8751.0002-1.0352.8419-1.8761 1.8761-1.8761 1.0344-.0001 1.8762.8409 1.8762 1.8761 0 1.0342-.842 1.8752-1.8762 1.8751z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235823504",
    d: "m23.7212 40.0632c-.1213 0-.2425-.0462-.3352-.1379l-1.6975-1.6988c-.1855-.1843-.1855-.4839-.0002-.6693.1845-.1844.4841-.1844.6684 0l1.6988 1.6986c.1853.1843.1852.4841-.0001.6695-.0926.0916-.213.138-.3342.1379z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235823240",
    d: "m36.8838 36.5092c-.5707 0-1.0343.4644-1.0343 1.0352.0001.5698.4634 1.0342 1.0342 1.0342s1.0342-.4644 1.0342-1.0342c0-.5709-.4634-1.0352-1.0341-1.0352zm0 3.0158c-1.0923 0-1.9808-.8883-1.9808-1.9806.0001-1.0924.8883-1.9816 1.9807-1.9816 1.0923-.0001 1.9806.8892 1.9806 1.9816.0002 1.0923-.8883 1.9806-1.9805 1.9806z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235822904",
    d: "m36.8838 36.5092c-.2613 0-.4734-.212-.4734-.4732l.0002-.9406c0-.2612.2118-.4732.4731-.4732.2614-.0001.4732.212.4732.4733v.9404c0 .2613-.2119.4733-.4731.4733z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235823288",
    d: "m37.9494 36.9508c-.1202 0-.2415-.0463-.3342-.138-.1842-.1854-.1844-.485 0-.6693l.6656-.6656c.1844-.1843.4839-.1843.6693.0001.1845.1853.1843.484 0 .6694l-.6653.6654c-.0927.0917-.2141.1381-.3354.138z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235822928",
    d: "m39.3327 38.0176h-.9414c-.2613 0-.4734-.212-.4734-.4732 0-.2623.2119-.4732.4732-.4732l.9416-.0001c.2613 0 .4721.211.4721.4733.0002.2612-.2109.4732-.4721.4732z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235823528",
    d: "m38.6149 39.7488c-.1211 0-.2426-.0463-.3342-.139l-.6653-.6645c-.1844-.1854-.1846-.485-.0002-.6694.1854-.1854.484-.1853.6694 0l.6657.6645c.1843.1853.1841.4851-.0002.6694-.0925.0927-.2139.139-.3352.139z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235822736",
    d: "m36.8838 40.4655c-.2613 0-.4734-.2119-.4734-.4732l.0002-.9406c0-.2612.2118-.4731.4731-.4731.2614 0 .4732.2119.4732.4732v.9405c0 .2613-.2119.4733-.4731.4732z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235822568",
    d: "m35.1527 39.7488c-.1213 0-.2427-.0463-.3354-.139-.1843-.1844-.1844-.4841 0-.6694l.6654-.6645c.1855-.1854.4851-.1853.6694 0 .1845.1844.1844.4841 0 .6694l-.6654.6644c-.0916.0928-.213.1391-.334.1391z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235822496",
    d: "m35.3763 38.0176h-.9414c-.2614 0-.4734-.212-.4734-.4732.0002-.2623.212-.4732.4732-.4732l.9416-.0001c.2613 0 .4732.211.4732.4733.0001.2612-.212.4732-.4732.4732z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235822400",
    d: "m35.8182 36.9508c-.1214 0-.2428-.0463-.3355-.138l-.6654-.6655c-.1843-.1854-.1844-.484 0-.6693.1854-.1844.485-.1844.6694 0l.6655.6654c.1844.1843.1843.4841-.0001.6694-.0926.0917-.2139.1381-.3339.138z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_235822304",
    d: "m19.907 4.4691h.0009zm.4732 20.9203h2.588v-1.9855c0-.2278.1625-.4239.3872-.4653.4614-.0858.9208-.2081 1.3655-.3648.2151-.076.4535.0118.5669.21l.9928 1.7183 2.2409-1.2944-.9938-1.7204c-.1133-.1972-.071-.4476.1015-.5964.3579-.3057.6941-.6418.9997-.9987.149-.1736.3983-.2159.5965-.1016l1.7204.9928 1.2934-2.2409-1.7173-.9919c-.1981-.1143-.286-.3528-.2101-.5678.1569-.4437.279-.903.3648-1.3654.0414-.2239.2376-.3864.4653-.3864l1.9846-.0001v-2.588h-1.9846c-.2276 0-.4239-.1626-.4653-.3874-.0857-.4614-.2081-.9208-.3648-1.3654-.0758-.215.0118-.4535.209-.5669l1.7184-.9918-1.2934-2.242-1.7204.9938c-.197.1135-.4476.0711-.5965-.1014-.3055-.357-.6418-.6931-.9997-.9997-.1724-.148-.2149-.3983-.1015-.5955l.9938-1.7214-2.2409-1.2935-.9928 1.7185c-.1134.197-.352.2849-.5669.21-.4435-.1568-.9031-.28-1.3655-.3658-.2246-.0415-.3874-.2376-.3874-.4653l.0002-1.9847h-2.588v1.9847c0 .2277-.1618.4239-.3866.4653-.4624.0858-.9219.209-1.3655.3658-.2149.0749-.4535-.0129-.5669-.21l-.9926-1.7185-2.2409 1.2935.9938 1.7214c.1133.1971.0708.4476-.1027.5955-.3567.3065-.6931.6428-.9987.9997-.1488.1724-.3993.2149-.5965.1015l-1.7202-.9939-1.2946 2.242 1.7185.9918c.1981.1133.2858.352.2099.5669-.1567.4446-.279.9041-.3648 1.3654-.0412.2248-.2376.3875-.4653.3875l-1.9856-.0001v2.588h1.9856c.2278 0 .4239.1627.4653.3865.0859.4623.2081.9218.3648 1.3654.076.2149-.0118.4536-.21.5679l-1.7184.9918 1.2946 2.2409 1.7202-.9928c.1972-.1144.4476-.0719.5965.1016.3057.3568.6418.6931.9987.9987.1736.1488.2159.3993.1025.5964l-.9936 1.7204 2.2409 1.2944.9928-1.7183c.1134-.1982.3518-.2859.5667-.21.4437.1567.9031.279 1.3655.3648.2248.0414.3864.2376.3864.4653zm3.0611.9464h-3.5343c-.2613 0-.4724-.2119-.4724-.4731l.0001-2.0734c-.2515-.0561-.501-.1232-.7464-.1991l-1.0361 1.7942c-.1311.2268-.4201.3048-.6468.1736l-3.061-1.7667c-.1085-.0631-.1875-.1666-.22-.2878-.0324-.1214-.0158-.2504.0473-.3589l1.0371-1.7974c-.1883-.1744-.3707-.3568-.5451-.5451l-1.7973 1.0381c-.1083.0622-.2376.079-.3589.0474-.1211-.0326-.2248-.1124-.2878-.2208l-1.7668-3.0612c-.1299-.2258-.0532-.5156.1736-.6467l1.7945-1.0352c-.0761-.2465-.1432-.4959-.1994-.7463l-2.0732-.0001c-.2613 0-.4733-.2119-.4733-.4731l.0002-3.5344c0-.2613.2118-.4732.473-.4732l2.0735-.0001c.0561-.2513.123-.5008.199-.7462l-1.7941-1.0363c-.227-.1311-.3039-.4199-.1738-.6467l1.7669-3.0602c.063-.1094.1665-.1882.2877-.2208.1213-.0326.2504-.0157.3589.0474l1.7974 1.0371c.1744-.1883.3567-.3697.545-.5452l-1.037-1.7972c-.0632-.1085-.08-.2376-.0474-.3589s.1114-.2248.2198-.2869l3.0614-1.7678c.1082-.0621.2374-.0797.3586-.0472.1214.0325.2248.1124.2879.2208l1.0362 1.7953c.2456-.0769.4949-.1429.7463-.2001l.0001-2.0724c0-.2613.2109-.4732.4721-.4732h3.5345c.2613 0 .4731.212.4731.4733l.0001 2.0722c.2515.0572.5008.1233.7463.2002l1.0362-1.7953c.063-.1085.1665-.1883.2878-.2208.1204-.0326.2504-.0148.3588.0473l3.0612 1.7676c.2258.1302.3036.4201.1725.6459l-1.0369 1.7972c.1881.1754.3705.3569.545.5452l1.7974-1.0372c.1085-.063.2375-.0798.3587-.0473.1213.0325.2248.1114.2869.2209l1.7679 3.0601c.0629.1095.0796.2386.0471.3589-.0325.1213-.1124.2248-.2209.2879l-1.794 1.0361c.0758.2455.1417.495.1989.7464l2.0725-.0001c.2622 0 .473.212.473.4733l.0002 3.5343c0 .2613-.2112.4733-.4734.4733l-2.0723-.0001c-.057.2505-.1232.4999-.1991.7464l1.7942 1.0351c.1085.0631.1883.1667.2209.2879.0327.1212.0158.2505-.0473.3589l-1.7676 3.0611c-.0621.1085-.1657.1884-.287.2209-.1211.0315-.2504.0148-.3588-.0473l-1.7973-1.0382c-.1744.1883-.3569.3708-.5452.5452l1.0372 1.7973c.1311.2258.0531.5156-.1726.6468l-3.0612 1.7666c-.2267.1311-.5156.0533-.6467-.1735l-1.036-1.7943c-.2456.0759-.4951.143-.7465.1992l.0001 2.0733c0 .2612-.212.4732-.4732.4731z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessManagement);
export default __webpack_public_path__ + "static/media/business_management.674e0909fc16825dcbe348a83d187326.svg";
export { ForwardRef as ReactComponent };